'use client';

import { ApiError } from '@arcane-ai/core/api';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';

const QueryProvider = ({ children }: { children: ReactNode }) => {
  // Create a stable QueryClient instance
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes
            // Retry network failures and server errors; a 4xx (signed out,
            // forbidden, not found) won't change on retry.
            retry: (failureCount, error) =>
              failureCount < 3 &&
              !(
                error instanceof ApiError &&
                error.status !== undefined &&
                error.status < 500
              ),
            refetchOnWindowFocus: false
          }
        }
      })
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default QueryProvider;
